<template>
    <kiosk-team-details :teamId="props.teamId">
        <div class="col-span-12 lg:col-span-10 flex flex-col w-full max-w-(--breakpoint-sm) justify-center">
            <page-header> Emergency Tools </page-header>
            <div class="max-w-(--breakpoint-sm) w-full flex flex-col gap-8">
                <vx-expandable-card>
                    <template v-slot:content>
                        <div class="flex flex-col gap-4">
                            <kiosk-team-feature
                                v-for="(feature, index) in features"
                                :key="features[index].id"
                                v-model="features[index]"
                                :teamId="props.teamId"
                            >
                            </kiosk-team-feature>
                        </div>
                    </template>
                </vx-expandable-card>
            </div>
        </div>
    </kiosk-team-details>
</template>

<script setup>
import KioskTeamDetails from '../details/KioskTeamDetails.vue';
import { VxExpandableCard } from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import { ref } from 'vue';
import KioskTeamFeature from '../features/KioskTeamFeature.vue';
import { adminFeaturesClient } from '~/services';
import { HTTP_INTERNAL_SERVER_ERROR, HTTP_NOT_FOUND } from '~/support/HttpStatuses';
import { useToasted } from '~/composables/useToasted';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
});

const toasted = useToasted();

const features = ref([]);

const getFeatures = async () => {
    try {
        const response = await adminFeaturesClient.getFeatures(props.teamId);
        features.value = response.data.data.filter((feature) => feature.type === 'break_glass');
    } catch (e) {
        if (
            !e?.response?.status ||
            e?.response?.status >= HTTP_INTERNAL_SERVER_ERROR ||
            e?.response?.status === HTTP_NOT_FOUND
        ) {
            toasted?.global.platform_error();
        } else {
            toasted?.error(e?.response?.data?.message || 'Something went wrong.');
        }
    }
};

getFeatures();
</script>
